// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__R8Mie","search":"Settings_search__1cT_1","filter":"Settings_filter__31sDa"};